import classNames from "classnames";
import React from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { Link, RouterState } from "react-router";
import { replace } from "react-router-redux";
import * as Redux from "redux";
import _ from "underscore";

import { LazyLoadImage, Loader } from "../../../core/atoms";
import { apiPromiseHook } from "../../../shared/flux/actions/enterHooks";
import { MatchState } from "../../../shared/helpers/reduxHelpers";
import { EnterHookPromises } from "../../state/enterHookPromises";
import { HeroSection } from "@travellocal/ui";
import { RoutesInvoker } from "./../../routesInvoker";

import "./customerEnquiries.scss";

interface StateProps {
  userState: IState<IUser>;
  enquiriesState: IState<IEnquirySummaryOutput[]>;
}
interface DispatchProps {
  redirectToEnquiry: (enquiryId: number) => void;
}

type Props = DispatchProps & StateProps;

export class CustomerEnquiriesComponent extends React.Component<Props> {
  public addImage(i: number): ILocationImage {
    return {
      id: 0,
      smallUrl: `/images/locations/0${i}.jpg`,
      largeUrl: `/images/locations/0${i}.jpg`,
      thumbnailUrl: `/images/locations/0${i}.jpg`,
      imageType: ImageType.Location,
      meta: null, // TODO: is this right?
      description: null,
      fileName: null,
    };
  }

  public componentWillMount() {
    const enquiries = this.props.enquiriesState?.data;
    if (enquiries?.length === 1) {
      this.props.redirectToEnquiry((enquiries[0].id));
    }
  }

  public render() {
    const { userState, enquiriesState } = this.props;

    if (this.props.enquiriesState.status !== "OK") {
      return <Loader />;
    }

    const images: ILocationImage[] = [];

    images.push(this.addImage(3));
    images.push(this.addImage(2));
    images.push(this.addImage(8));
    images.push(this.addImage(4));
    images.push(this.addImage(5));

    return (
      <div className="customer-all-enquiries">
        {MatchState(userState, {
          none: () => <Helmet title="Loading..." />,
          data: user => <Helmet title={`My trips`} />,
        })}

        <HeroSection images={images}>
          {MatchState(userState, {
            none: () => <h1>Loading...</h1>,
            data: user => <h1>My trips</h1>,
          })}
        </HeroSection>

        <div className="enquiries-list width-wrapper">
          {MatchState(enquiriesState, {
            none: () => <Loader />,
            data: enquiries => enquiries.map(enquiry => {
              const enquiryLocation = enquiry.messagingSummary.initialMessage.location;
              const imageUrl = enquiry.isConnected && enquiry.lto.image ? enquiry.lto.image.regularUrl : "/missing-image.jpg";

              return (
                <div
                  key={enquiry.id}
                  className={classNames("enquiry-card", { cancelled: enquiry.enquiryStatus === EnquiryStatus.Cancelled })}
                >
                  <LazyLoadImage className="hero" src={imageUrl} alt="" />

                  <div className="summary">
                    <h2>{enquiryLocation ? `My enquiry for ${enquiryLocation.name}` : "My enquiry"}</h2>
                    <hr />
                    <div className={classNames("label", "text--caps")}>Reference</div>
                    <div className="reference">{enquiry.reference}</div>
                  </div>
                  <Link className="link" to={RoutesInvoker.customerEnquiriesIndex(enquiry.id)} />
                </div>
              );
            }),
          })}
        </div>
      </div>
    );
  }
}

const stateToProps = (state: IWebStoreState): StateProps => ({
  userState: state.user,
  enquiriesState: state.customerEnquiries,
});

const dispatchToProps = (dispatch): DispatchProps => ({
  redirectToEnquiry: (enquiryId: number) => dispatch(replace(RoutesInvoker.customerEnquiriesIndex(enquiryId))),
});

export const CustomerEnquiries = connect(stateToProps, dispatchToProps)(CustomerEnquiriesComponent);

export const customerEnquiriesOnEnter = apiPromiseHook(EnterHookPromises.allEnquiriesForCustomer());
